import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const policySections = [
    {
      id: "collection",
      title: "1. Information We Collect",
      intro: "We may collect the following information to provide a better experience:",
      list: [
        "Personal details: Name, email, and phone number",
        "Business details: Information related to your insurance services",
        "Customer data: Data uploaded by you for management purposes",
        "Technical data: Device and usage data used for platform improvement"
      ]
    },
    {
      id: "usage",
      title: "2. How We Use Your Information",
      list: [
        "To provide, maintain, and improve our digital services",
        "To communicate critical updates, support, and service notices",
        "To ensure platform security and regulatory compliance",
        "To process payments and manage your subscriptions"
      ]
    },
    {
      id: "security",
      title: "3. Data Security",
      content: "We use reasonable technical and organizational measures to protect your data. However, please be aware that no online system is 100% secure, and we cannot guarantee absolute security."
    },
    {
      id: "sharing",
      title: "4. Data Sharing",
      content: "We respect your privacy: we do not sell or rent your personal data. Data may only be shared with trusted service providers for platform operations or if required by law or government authorities."
    },
    {
      id: "responsibility",
      title: "5. Customer Data Responsibility",
      content: "Insurance customer data uploaded by agents remains the sole responsibility of the user. PolicySaath does not claim ownership of your customer data."
    },
    {
      id: "cookies",
      title: "6. Cookies",
      content: "We may use cookies to enhance your user experience, analyze platform usage, and improve our overall performance."
    },
    {
      id: "rights",
      title: "7. Your Rights",
      content: "You have the right to request access, correction, or deletion of your personal information. Please reach out to our team for such requests."
    }
  ];

  return (
    <>
    <Header/>
        <div className="privacy-page">
      {/* Header Section */}
      <header className="privacy-header">
        <div className="container mt-5">
          {/* <span className="subtitle">Security & Trust</span> */}
          <h1>Privacy Policy</h1>
          <p>PolicySaath respects your privacy and is committed to protecting your personal and business information.</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="privacy-body">
        <div className="container">
          <div className="policy-card-grid">
            {policySections.map((section) => (
              <div key={section.id} className="policy-card">
                <h3>{section.title}</h3>
                {section.intro && <p className="intro-text">{section.intro}</p>}
                {section.content && <p>{section.content}</p>}
                {section.list && (
                  <ul className="policy-list">
                    {section.list.map((item, index) => (
                      <li key={index}>
                        <i className="bi bi-shield-check"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}

            {/* Contact Information */}
            <div className="policy-card contact-highlight">
              <h3>8. Contact Us</h3>
              <p>For any questions regarding this policy or your data, please contact us:</p>
              <div className="contact-links">
                <a href="mailto:policysaath@gmail.com">
                  <i className="bi bi-envelope-at"></i> policysaath@gmail.com
                </a>
                <a href="tel:+919136356555">
                  <i className="bi bi-telephone"></i> +91-9136356555
                </a>
              </div>
            </div>
          </div>
          
          <div className="policy-footer">
            <p>This policy may be updated periodically. Continued use of the platform indicates your acceptance of these terms.</p>
          </div>
        </div>
      </main>
    </div>
    <Footer/>
    </>
  );
};

export default PrivacyPolicy;